import api from '@/api/api'

export default {
    async fetchBy(params) {
        try {
            let resp = await api.get(`/api/district/students`, { params })

            return resp.data
        } catch (err) {
            throw 'Error fetching students'
        }
    },
}
